import React, { useState, useEffect } from 'react';
import { Button, TextField } from '@mui/material';
import MicIcon from "@mui/icons-material/Mic";
import MicOffIcon from "@mui/icons-material/MicOff";
import { token_api } from "../../Utils/Network";

const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
const mic = SpeechRecognition ? new SpeechRecognition() : null;
if (mic) {
  mic.continuous = true;
  mic.interimResults = true;
  mic.lang = "en-US";
}

const GenericCategoryComponent = ({ category, sessionId, userId, valueFromProps = "" }) => {
  const [isListening, setIsListening] = useState(false);
  const [value, setValue] = useState(valueFromProps || "");
  const [card, setCard] = useState(false);
  const [edit, setEdit] = useState(false);

  useEffect(() => {
    setValue(valueFromProps || "");
  }, [valueFromProps]);

  useEffect(() => {
    if (!mic) return;
    if (isListening) {
      mic.start();
      mic.onend = () => mic.start();
    } else {
      mic.stop();
      mic.onend = () => {};
    }
    mic.onresult = (event) => {
      const transcript = Array.from(event.results)
        .map((result) => result[0])
        .map((result) => result.transcript)
        .join("");
      setValue(transcript);
    };
    mic.onerror = (event) => {};
    return () => mic.stop();
  }, [isListening, category.title]);

  const handleSave = async (e) => {
    e.preventDefault();
    setCard(true);
    let data = {
      user_id: userId,
      extra_information: {
        session: sessionId,
      },
    };
    // Set the correct field based on category
    if (category.title === "Student Profile") {
      data.extra_information.student_profile = value;
    } else if (category.title === "Area of Concern") {
      data.extra_information.area_of_concern = value;
    } else if (category.title === "Recommendation") {
      data.extra_information.recommendation = value;
    } else {
      // For other categories, use a generic field
      data.extra_information[category.title.replace(/ /g, "_").toLowerCase()] = value;
    }
    await token_api.post(`/counseling/add/student/update_student_profile/?user=${userId}`, data);
    setEdit(true);
  };

  const toggleEdit = () => {
    setCard(false);
    setEdit(false);
  };

  return (
    <div style={{ marginTop: 16, padding: 8, background: '#f9f9f9', borderRadius: 4 }}>
      <div style={{ display: "flex", gap: "20px", alignItems: "center", marginBottom: 8 }}>
        <span style={{ fontWeight: 500, marginRight: 8 }}>{category.title}</span>
        {isListening ? (
          <MicIcon sx={{ color: "#02f733" }} onClick={() => setIsListening(false)} />
        ) : (
          <MicOffIcon sx={{ color: "#f71302" }} onClick={() => setIsListening(true)} />
        )}
        {edit && (
          <span style={{ cursor: "pointer", marginLeft: 16 }} onClick={toggleEdit}>
            Edit
          </span>
        )}
      </div>
      {!card ? (
        <form onSubmit={handleSave}>
          <TextField
            fullWidth
            label={category.title}
            multiline
            rows={4}
            value={value}
            onChange={e => setValue(e.target.value)}
            required
          />
          <div style={{ textAlign: "right" }}>
            <Button
              style={{
                marginTop: "10px",
                backgroundColor: "#2f327d",
                color: "#ffffff",
                padding: "6px 20px",
                borderRadius: "6px",
                fontWeight: 600,
                textTransform: "none",
                cursor: "pointer",
                border: "none",
              }}
              size="small"
              variant="contained"
              type="submit"
            >
              Save
            </Button>
          </div>
        </form>
      ) : (
        <div style={{ marginTop: 8, minHeight: 60 }}>
          {value}
        </div>
      )}
    </div>
  );
};

export default GenericCategoryComponent; 